import { render, staticRenderFns } from "./SelectStatic.vue?vue&type=template&id=381ffbaa&scoped=true&"
import script from "./SelectStatic.vue?vue&type=script&lang=js&"
export * from "./SelectStatic.vue?vue&type=script&lang=js&"
import style0 from "./SelectStatic.vue?vue&type=style&index=0&id=381ffbaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381ffbaa",
  null
  
)

export default component.exports